import baustein from "baustein";
import store from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import { addCollection, clearCollection } from "web/redux/ducks/collection-bar";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import { watchState } from "web/redux/state-watcher";

import "web/script/components/lazy-image";
import "web/script/components/lead-link";
import "web/script/components/show-extra";
import "web/script/components/tracked-link";
import "web/script/components/wishlist-delete";

const PRODUCT_CARD_CLASSES = [".collection-product-card"];
let currentCount = 1;

function collection(state) {
    return {
        productId: state.collectionBarReducer.lastRemovedProductId,
        count: state.collectionBarReducer.collectionCount,
    };
}

export default baustein.register("collection-product-card-ta-collection", {
    defaultOptions: {
        newTabEnabled: false,
        overlayEnabled: false,
        productSlug: null,
        productId: null,
        productUid: null,
        productGender: null,
        reason: null,
        inStock: true,
        hasTooltip: false,
        linkId: null,
        useOverlayOnMobile: false,
    },

    setupEvents(add) {
        add("click", PRODUCT_CARD_CLASSES, this.toggleCollection);
    },

    init() {
        this.unsubscribeToCollectionWatcher = watchState(collection, (collectionData) => {
            currentCount = collectionData.count;

            if (this.options.productId != collectionData.productId) {
                return false;
            } else {
                this.el.classList.remove("collection-product-card-collection-added");
            }
        });
    },

    toggleCollection() {
        const currentCard = this.el;
        if (currentCard.classList.contains("collection-product-card-collection-added")) {
            analytics.event("ta_collection", "ta_collection_cp_off", "product_card");
            store.dispatch(clearCollection(this.options.productId.toString()));
        } else if (currentCount < 2) {
            analytics.event("ta_collection", "ta_collection_cp_on", "product_card");
            store.dispatch(
                addCollection({
                    productId: this.options.productId.toString(),
                    productImageUrl: currentCard.querySelector("img").getAttribute("src"),
                })
            );
            currentCard.classList.add("collection-product-card-collection-added");
        } else {
            store.dispatch(openCustomerCaptureOverlay({ captureType: "ta_collection" }));
        }
    },

    onRemove() {
        this.unsubscribeToCollectionProductIdWatcher();
    },
});
